<template lang="pug">
.event-info-content
  .d-flex.justify-space-between
    div
      p.event-info-content__date-title Даты проведения
      span.event-info-content__date
        | {{ data.event_stage_start_at | localeFormatDefault | readableDate }}
        | - {{ data.event_stage_end_at | localeFormatDefault | readableDate }}
    v-btn.ml-auto(icon small @click)
      v-icon(color="redesignBlack" @click="$emit('close')") $iclose
  app-tabs-group.event-info-content__tabs(
    ref="tabs"
    v-model="tab"
    :items="tabs"
  )

  v-tabs-items.event-info-content__content(v-model='tab')
    v-tab-item.event-info-content__tab-content
      .headline.weight-500 Описание
      event-info-chips.my-4(:event="data" color="redesignBackground")
      description-tab(:texts="data.announcement")

    v-tab-item.event-info-content__tab-content
      description-tab(:texts="data.target")

    v-tab-item.event-info-content__tab-content
      documents-tab(:eventId="data.id")
</template>

<script>
import AppTabsGroup from '@/components/user-redesign/controls/AppTabsGroup.vue';
import DocumentsTab from '../DocumentsTab.vue';
import DescriptionTab from '../DescriptionTab.vue';
import EventInfoChips from '../EventInfoChips.vue';
import mixinTime from '@/mixins/mixinTime';
import { localeFormatDefault } from '@/plugins/date-print';

export default {
  name: 'EventInfoContent',

  filters: {
    localeFormatDefault,
  },

  components: {
    AppTabsGroup,
    DocumentsTab,
    DescriptionTab,
    EventInfoChips,
  },

  mixins: [mixinTime],

  props: {
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      tab: 0,
      tabs: [
        { value: 0, text: 'Описание' },
        { value: 1, text: 'Цели и задачи' },
        { value: 2, text: 'Документы' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.event-info-content {

  &__date-title {
    color: #{$redesignBlack};
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  &__date {
    display: inline-block;
    margin-top: 16px;
    padding: 12px;
    color: #{$redesignBlack};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-radius: 12px;
    background-color: #{$redesignBackground};
  }

  &__tabs {
    margin-top: 24px;
  }

  &__content {
    margin-top: 24px;
  }
}
</style>
